module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-register-module/master-register-module.component.scss
// module id = ./src/app/master/master-register-module/master-register-module.component.scss
// module chunks = main